import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as applicationActions from '../../actions/application';
import { APPLICATION_CONTEXTS } from '../../constants';
import ImageHeader from '../common/imageHeader';
import ImageText from '../common/imageText';
import ImageButtonList from '../common/imageButtonList';
import NavigationBar from '../common/navigationBar';
import ServiceNavigationBar from '../common/serviceNavigationBar';
import Popup from './Popup';

class FeedbackQuestion extends Component {
  handleOnSelect = id => {
    console.log(id);
    this.selectAnswer(id);
  };

  handleKeyUp = (index, key) => {
    if (this.props.context !== APPLICATION_CONTEXTS.SERVICES) {
      return;
    }
    const currentSurvey = this.getSurvey();
    const currentQuestion = this.getQuestionIndex();
    let currentType = currentSurvey.questions[currentQuestion].type;
    let currentList = this.state.currentList;
    let currentAnswer = this.state.currentAnswer;
    switch (this.state.currentList) {
      case this.SERVICE_LIST:
        if (key === 'ArrowUp') {
          currentList = this.QUESTION_LIST;
          if (currentType === "rating-selection") {
            currentAnswer = currentSurvey.questions[currentQuestion].answers.length - 4;
            this.updateRatingHighlight(currentAnswer);
            this.selectAnswer(currentAnswer);
          } else {
            currentAnswer = currentSurvey.questions[currentQuestion].answers.length - 1;
          }
        }
        break;
      case this.QUESTION_LIST:
        if (key === 'ArrowLeft' | key === 'ArrowRight') {
          if (currentType === "rating-selection") {
            currentAnswer = index;
            this.updateRatingHighlight(index);
          }
        } else  
      if (key === 'ArrowDown' && currentSurvey.questions[currentQuestion].answers.length - 1 === index) {
          currentList = this.SERVICE_LIST;
        }
        break;
      default:
        console.log('FeedbackQuestion::handleKeyUp() - Unknown list: %o', this.state.currentList);
        return;
    }
    if (this.state.currentList !== currentList || this.state.currentAnswer !== currentAnswer) {
      this.setState({
        currentList: currentList,
        currentAnswer: currentAnswer
      });
    }
  };

  handleQuestionPrevious = () => {
    console.log("Previous Question");
    const nextQuestionNumber = parseInt(this.props.match.params.question, 10) - 1;
    if (nextQuestionNumber > 0) {
      this.goToQuestion(nextQuestionNumber);
    }
    this.setState({
      currentList: this.QUESTION_LIST
    });
  };

  handleQuestionNext = answerId => {
    console.log("Next Question");
    const nextQuestionNumber = parseInt(this.props.match.params.question, 10) + 1;
    if (nextQuestionNumber <= this.getSurvey().questions.length) {
      this.goToQuestion(nextQuestionNumber, answerId);
    }
    this.setState({
      currentList: this.QUESTION_LIST
    });
  };

  /**************
   * Properties *
   **************/
  QUESTION_LIST = 'questionList';
  SERVICE_LIST = 'serviceList';
  state = {
    defaultAdmission: {
      name:'defaultAdmission',
      questions: [
        {
          id: 'question1',
          maxSelections: 1,
          selectedAnswers: ['0'],
          flex: "flex-vertical",
          type: "text-selection",
          question: require('./images/1210_question1_satisfactory.png'),
          answers: [
            {
              id: 'yes',
              highlight: require('./images/Questions_Yes_HL.png'),
              unhighlight: require('./images/Questions_Yes_UH.png'),
              handleSelect: this.handleOnSelect,
            },
            {
              id: 'no',
              highlight: require('./images/Questions_No_HL.png'),
              unhighlight: require('./images/Questions_No_UH.png'),
              handleSelect: this.handleOnSelect
            }
          ]
        }
      ]
    },
    defaultRating: {
      name:'defaultRating',
      questions: [
        {
          id: 'question1',
          maxSelections: 1,
          selectedAnswers: ['0'],
          flex: "flex-vertical",
          type: "image-selection",
          question: require('./images/1210_RateMyCare_question2.png'),
          answers: [
            {
              id: 'positive',
              highlight: require('./images/1210_Emoji_good_HL.png'),
              unhighlight: require('./images/1210_Emoji_good_UH.png'),
              handleSelect: this.handleOnSelect,
            },
            {
              id: 'neutral',
              highlight: require('./images/1210_Emoji_neutral_HL.png'),
              unhighlight: require('./images/1210_Emoji_neutral_UH.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: 'negative',
              highlight: require('./images/1210_Emoji_bad_HL.png'),
              unhighlight: require('./images/1210_Emoji_bad_UH.png'),
              handleSelect: this.handleOnSelect
            }
          ]
        },
        {
          id: 'question2',
          maxSelections: 1,
          selectedAnswers: ['6'],
          flex: "flex-horizontal",
          custom_image: require('./images/1210_RatingStar_HL.png'),
          type: "rating-selection",
          question: require('./images/1210_RateMyCare_question3.png'),
          answers: [
            {
              id: '1',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '2',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '3',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '4',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '5',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '6',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '7',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect,
              selected: true
            },
            {
              id: '8',
              highlight: require('./images/1210_RatingStar_UH.png'),
              unhighlight: require('./images/1210_RatingStar_UH.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '9',
              highlight: require('./images/1210_RatingStar_UH.png'),
              unhighlight: require('./images/1210_RatingStar_UH.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '10',
              highlight: require('./images/1210_RatingStar_UH.png'),
              unhighlight: require('./images/1210_RatingStar_UH.png'),
              handleSelect: this.handleOnSelect
            },
          ]
        }
      ]
    },
    orthoPatientAdmission: {
      name:'orthoPatientAdmission',
      questions: [
        {
          id: 'question1',
          maxSelections: 1,
          selectedAnswers: ['0'],
          flex: "flex-vertical",
          type: "text-selection",
          question: require('./images/1210_question1_satisfactory.png'),
          answers: [
            {
              id: 'yes',
              highlight: require('./images/Questions_Yes_HL.png'),
              unhighlight: require('./images/Questions_Yes_UH.png'),
              handleSelect: this.handleOnSelect,
            },
            {
              id: 'no',
              highlight: require('./images/Questions_No_HL.png'),
              unhighlight: require('./images/Questions_No_UH.png'),
              handleSelect: this.handleOnSelect
            }
          ]
        }
      ]
    },
    orthoPatientRating: {
      name:'orthoPatientRating',
      questions: [
        {
          id: 'question1',
          maxSelections: 1,
          selectedAnswers: ['0'],
          flex: "flex-vertical",
          type: "image-selection",
          question: require('./images/1210_RateMyCare_question2.png'),
          answers: [
            {
              id: 'positive',
              highlight: require('./images/1210_Emoji_good_HL.png'),
              unhighlight: require('./images/1210_Emoji_good_UH.png'),
              handleSelect: this.handleOnSelect,
            },
            {
              id: 'neutral',
              highlight: require('./images/1210_Emoji_neutral_HL.png'),
              unhighlight: require('./images/1210_Emoji_neutral_UH.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: 'negative',
              highlight: require('./images/1210_Emoji_bad_HL.png'),
              unhighlight: require('./images/1210_Emoji_bad_UH.png'),
              handleSelect: this.handleOnSelect
            }
          ]
        },
        {
          id: 'question2',
          maxSelections: 1,
          selectedAnswers: ['6'],
          flex: "flex-horizontal",
          custom_image: require('./images/1210_RatingStar_HL.png'),
          type: "rating-selection",
          question: require('./images/1210_RateMyCare_question3.png'),
          answers: [
            {
              id: '1',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '2',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '3',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '4',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '5',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '6',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '7',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect,
              selected: true
            },
            {
              id: '8',
              highlight: require('./images/1210_RatingStar_UH.png'),
              unhighlight: require('./images/1210_RatingStar_UH.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '9',
              highlight: require('./images/1210_RatingStar_UH.png'),
              unhighlight: require('./images/1210_RatingStar_UH.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '10',
              highlight: require('./images/1210_RatingStar_UH.png'),
              unhighlight: require('./images/1210_RatingStar_UH.png'),
              handleSelect: this.handleOnSelect
            },
          ]
        }
      ]
    },
    chfPatientAdmission: {
      name:'chfPatientAdmission',
      questions: [
        {
          id: 'question1',
          maxSelections: 1,
          selectedAnswers: ['0'],
          flex: "flex-vertical",
          type: "text-selection",
          question: require('./images/1210_question1_satisfactory_chf.png'),
          answers: [
            {
              id: 'yes',
              highlight: require('./images/Questions_Yes_HL.png'),
              unhighlight: require('./images/Questions_Yes_UH.png'),
              handleSelect: this.handleOnSelect,
            },
            {
              id: 'no',
              highlight: require('./images/Questions_No_HL.png'),
              unhighlight: require('./images/Questions_No_UH.png'),
              handleSelect: this.handleOnSelect
            }
          ]
        },
        {
          id: 'question2',
          maxSelections: 1,
          selectedAnswers: ['0'],
          flex: "flex-vertical",
          type: "text-selection",
          question: require('./images/1210_question2_admitted_chf.png'),
          answers: [
            {
              id: 'yes',
              highlight: require('./images/Questions_Yes_HL.png'),
              unhighlight: require('./images/Questions_Yes_UH.png'),
              handleSelect: this.handleOnSelect,
            },
            {
              id: 'no',
              highlight: require('./images/Questions_No_HL.png'),
              unhighlight: require('./images/Questions_No_UH.png'),
              handleSelect: this.handleOnSelect
            }
          ]
        }
      ]
    },
    chfPatientRating: {
      name:'chfPatientRating',
      questions: [
        {
          id: 'question1',
          maxSelections: 1,
          selectedAnswers: ['0'],
          flex: "flex-vertical",
          type: "image-selection",
          question: require('./images/1210_RateMyCare_question2.png'),
          answers: [
            {
              id: 'positive',
              highlight: require('./images/1210_Emoji_good_HL.png'),
              unhighlight: require('./images/1210_Emoji_good_UH.png'),
              handleSelect: this.handleOnSelect,
            },
            {
              id: 'neutral',
              highlight: require('./images/1210_Emoji_neutral_HL.png'),
              unhighlight: require('./images/1210_Emoji_neutral_UH.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: 'negative',
              highlight: require('./images/1210_Emoji_bad_HL.png'),
              unhighlight: require('./images/1210_Emoji_bad_UH.png'),
              handleSelect: this.handleOnSelect
            }
          ]
        },
        {
          id: 'question2',
          maxSelections: 1,
          selectedAnswers: ['6'],
          flex: "flex-horizontal",
          custom_image: require('./images/1210_RatingStar_HL.png'),
          type: "rating-selection",
          question: require('./images/1210_RateMyCare_question3.png'),
          answers: [
            {
              id: '1',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '2',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '3',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '4',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '5',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '6',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '7',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect,
              selected: true
            },
            {
              id: '8',
              highlight: require('./images/1210_RatingStar_UH.png'),
              unhighlight: require('./images/1210_RatingStar_UH.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '9',
              highlight: require('./images/1210_RatingStar_UH.png'),
              unhighlight: require('./images/1210_RatingStar_UH.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '10',
              highlight: require('./images/1210_RatingStar_UH.png'),
              unhighlight: require('./images/1210_RatingStar_UH.png'),
              handleSelect: this.handleOnSelect
            },
          ]
        }
      ]
    },
    pediatricPatientAdmission: {
      name:'pediatricPatientAdmission',
      questions: [
        {
          id: 'question1',
          maxSelections: 1,
          selectedAnswers: ['0'],
          flex: "flex-vertical",
          type: "text-selection",
          question: require('./images/1210_question1_admission_concerns.png'),
          answers: [
            {
              id: 'yes',
              highlight: require('./images/Questions_Yes_HL.png'),
              unhighlight: require('./images/Questions_Yes_UH.png'),
              handleSelect: this.handleOnSelect,
            },
            {
              id: 'no',
              highlight: require('./images/Questions_No_HL.png'),
              unhighlight: require('./images/Questions_No_UH.png'),
              handleSelect: this.handleOnSelect
            }
          ]
        }
      ]
    },
    pediatricPatientRating: {
      name:'defaultRating',
      questions: [
        {
          id: 'question1',
          maxSelections: 1,
          selectedAnswers: ['0'],
          flex: "flex-vertical",
          type: "image-selection",
          question: require('./images/1210_RateMyCare_question2.png'),
          answers: [
            {
              id: 'positive',
              highlight: require('./images/1210_Emoji_good_HL.png'),
              unhighlight: require('./images/1210_Emoji_good_UH.png'),
              handleSelect: this.handleOnSelect,
            },
            {
              id: 'neutral',
              highlight: require('./images/1210_Emoji_neutral_HL.png'),
              unhighlight: require('./images/1210_Emoji_neutral_UH.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: 'negative',
              highlight: require('./images/1210_Emoji_bad_HL.png'),
              unhighlight: require('./images/1210_Emoji_bad_UH.png'),
              handleSelect: this.handleOnSelect
            }
          ]
        },
        {
          id: 'question2',
          maxSelections: 1,
          selectedAnswers: ['6'],
          flex: "flex-horizontal",
          custom_image: require('./images/1210_RatingStar_HL.png'),
          type: "rating-selection",
          question: require('./images/1210_RateMyCare_question3.png'),
          answers: [
            {
              id: '1',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '2',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '3',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '4',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '5',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '6',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '7',
              highlight: require('./images/1210_RatingStar_HL.png'),
              unhighlight: require('./images/1210_RatingStar_HL.png'),
              handleSelect: this.handleOnSelect,
              selected: true
            },
            {
              id: '8',
              highlight: require('./images/1210_RatingStar_UH.png'),
              unhighlight: require('./images/1210_RatingStar_UH.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '9',
              highlight: require('./images/1210_RatingStar_UH.png'),
              unhighlight: require('./images/1210_RatingStar_UH.png'),
              handleSelect: this.handleOnSelect
            },
            {
              id: '10',
              highlight: require('./images/1210_RatingStar_UH.png'),
              unhighlight: require('./images/1210_RatingStar_UH.png'),
              handleSelect: this.handleOnSelect
            },
          ]
        }
      ]
    },
    headerImage: require(`./images/Question${this.props.match.params.question}.png`),
    textImage: require('./images/1210_elements_questions.png'),
    navigationBar: {
      back: false,
      backRoute: `/feedback/question/${this.props.match.params.survey}/${this.props.match.params.question}/exit`,
      mainMenu: true,
      navigate: true
    },
    serviceNavigationBar: {
      buttons: [
        {
          id: 'exit',
          to: `/feedback/question/${this.props.match.params.survey}/${this.props.match.params.question}/exit`,
          highlight: require('./images/btn_exit_HL.png'),
          unhighlight: require('./images/btn_exit_UH.png'),
          disable: require('./images/btn_exit_disabled.png'),
          disabled: false,
          hidden: false
        },
        {
          id: 'previous',
          handleSelect: this.handleQuestionPrevious,
          highlight: require('./images/btn_previous_HL.png'),
          unhighlight: require('./images/btn_previous_UH.png'),
          disable: require('./images/btn_previous_disabled.png'),
          disabled: true,
          hidden: true
        },
        {
          id: 'next',
          handleSelect: this.handleQuestionNext,
          highlight: require('./images/btn_next_HL.png'),
          unhighlight: require('./images/btn_next_UH.png'),
          disable: require('./images/btn_next_disabled.png'),
          disabled: true,
          hidden: false
        },
        {
          id: 'submit',
          to: `/feedback/question/${this.props.match.params.survey}/${this.props.match.params.question}/submit`,
          highlight: require('./images/btn_submit_HL.png'),
          unhighlight: require('./images/btn_submit_UH.png'),
          disable: require('./images/btn_submit_disabled.png'),
          disabled: true,
          hidden: true
        }
      ],
      default: 0
    },
    currentAnswer: this.props.match.params.answer || 1,
    currentList: this.QUESTION_LIST,
    headerImageStyles: {
      unit: 'rem',
      top: 1.9,
      left: 60
    }
  };

  /*******************
   * Private methods *
   *******************/

  getCurrentAnswerIndex = (answerId = null) => {
    const currentSurvey = this.getSurvey();
    const currentQuestion = this.getQuestionIndex();
    if (answerId !== null) {
      return currentSurvey.questions[currentQuestion].answers.findIndex(answer => {
        return answer.id === answerId;
      });
    }
    if (this.props.match.params.answer) {
      let answerNumber = this.props.match.params.answer - 1;
      if (answerNumber < 0) {
        answerNumber = 0;
      } else if (answerNumber >= currentSurvey.questions[currentQuestion].answers.length) {
        answerNumber = currentSurvey.questions[currentQuestion].answers.length - 1;
      }
      return answerNumber;
    }
  };

  getQuestionIndex = (props = this.props) => {
    const currentSurvey = this.getSurvey(props);
    let questionNumber = props.match.params.question - 1;
    if (questionNumber < 0) {
      questionNumber = 0;
    } else if (questionNumber >= currentSurvey.questions.length) {
      questionNumber = currentSurvey.questions.length - 1;
    }
    return questionNumber;
  };

  getSurvey = (props = this.props) => {
    return this.state[props.match.params.survey];
  };

  updateHighlight = (surveyId, questionIdx, answerIdx, key, value) => {
    this.setState((prevState) => {
      const survey = { ...prevState[surveyId] };
      const questions = survey.questions = [...survey.questions];
      const currentQuestion = questions[questionIdx] = { ...questions[questionIdx] };
      const answers = currentQuestion.answers = [...currentQuestion.answers];
      const currentAnswer = answers[answerIdx] = { ...answers[answerIdx] };
      currentAnswer[key] = value;

      return { ...prevState, [surveyId]: survey };
    });
  };

  updateRatingHighlight = (currentIdx) => {
    const currentSurvey = this.getSurvey();
    const currentQuestion = this.getQuestionIndex();
    const replaceHighlight = require('./images/1210_RatingStar_HL.png');
    const replaceUnHighlight = require('./images/1210_RatingStar_UH.png');
    var X;
    for(X = 0; X < currentSurvey.questions[currentQuestion].answers.length; X++) {
      if(X <= currentIdx) {
        this.updateHighlight(currentSurvey.name, currentQuestion, X, "unhighlight", replaceHighlight);
        this.updateHighlight(currentSurvey.name, currentQuestion, X, "highlight", replaceHighlight);
      } else if (X >= currentIdx) {
        this.updateHighlight(currentSurvey.name, currentQuestion, X, "unhighlight", replaceUnHighlight);
        this.updateHighlight(currentSurvey.name, currentQuestion, X, "highlight", replaceUnHighlight);
      }
    }
  };

  getUpdatedServiceNavigationBar = (selectedAnswers = [], props = this.props) => {
    const survey = this.getSurvey(props);
    const question = this.getQuestionIndex(props);

    let exit = this.state.serviceNavigationBar.buttons.find(button => {
      return button.id === 'exit';
    });
    exit.disabled = question !== 0;
    exit.hidden = question !== 0;

    let previous = this.state.serviceNavigationBar.buttons.find(button => {
      return button.id === 'previous';
    });
    previous.disabled = !(question > 0);
    previous.hidden = !(question > 0);

    let next = this.state.serviceNavigationBar.buttons.find(button => {
      return button.id === 'next';
    });
    next.disabled = selectedAnswers.length === 0 || question === survey.questions.length - 1;

    let submit = this.state.serviceNavigationBar.buttons.find(button => {
      return button.id === 'submit';
    });
    submit.disabled = selectedAnswers.length === 0;
    submit.hidden = !(question === survey.questions.length - 1);
    submit.to = `/feedback/question/${this.props.match.params.survey}/${this.props.match.params.question}/submit`;

    let defaultButton = selectedAnswers.length === 0 ? 0 : 1;
    if (selectedAnswers.length > 0 && submit.hidden === false) {
      defaultButton = 2;
    }

    return { buttons: [exit, previous, next, submit], default: defaultButton };
  };

  goToQuestion = (questionNumber, answerId = null) => {
    const currentSurvey = this.props.match.params.survey;
    this.setState({
      navigationBar: Object.assign({}, this.state.navigationBar, {
        backRoute: `/feedback/question/${currentSurvey}/${questionNumber}/exit`
      })
    });
    this.props.history.push(`/feedback/question/${currentSurvey}/${questionNumber}`);
  };

  selectAnswer = answerId => {
    const currentSurveyName = this.props.match.params.survey;
    const currentSurvey = this.getSurvey();
    const currentQuestion = this.getQuestionIndex();
    let currentType = currentSurvey.questions[currentQuestion].type;
    let currentSurveyState = this.getSurvey();
    let selectedAnswers = Array.from(
      currentSurveyState.questions[this.props.match.params.question - 1].selectedAnswers
    );
    // Loop #1: Find the selected answer and mark it accordingly
    currentSurveyState.questions = currentSurveyState.questions.map((question, questionIndex) => {
      if (questionIndex === this.props.match.params.question - 1) {
        return Object.assign({}, question, {
          answers: currentSurveyState.questions[questionIndex].answers.map((answer, answerIndex) => {
            if (answer.id === answerId) {
              if (currentSurveyState.questions[questionIndex].answers[answerIndex].checked) {
                selectedAnswers = selectedAnswers.filter(aIdx => aIdx !== answerIndex);
              } else {
                selectedAnswers.push(answerIndex);
              }
              if (currentType === "rating-selection") { 
                console.log("Selected");
                return Object.assign({}, answer, {
                  selected: !currentSurveyState.questions[questionIndex].answers[answerIndex].selected
                });
              } else {
                console.log("Checked");
                return Object.assign({}, answer, {
                  checked: !currentSurveyState.questions[questionIndex].answers[answerIndex].checked
                });
              }
              
            } else {
              return answer;
            }
          })
        });
      } else {
        return question;
      }
    });
    console.log(selectedAnswers);
    // Loop #2: Check the maxSelections and determine if an item needs to be unchecked
    currentSurveyState.questions = currentSurveyState.questions.map((question, questionIndex) => {
      if (questionIndex === this.props.match.params.question - 1) {
        return Object.assign({}, question, {
          answers: currentSurveyState.questions[questionIndex].answers.map((answer, answerIndex) => {
            if (
              selectedAnswers.length > currentSurveyState.questions[questionIndex].maxSelections &&
              currentSurveyState.questions[questionIndex].answers[answerIndex].checked &&
              selectedAnswers.indexOf(answerIndex) === 0
            ) {
              selectedAnswers.shift();
              return Object.assign({}, answer, {
                checked: false
              });
            } else {
              return answer;
            }
          }),
          selectedAnswers: selectedAnswers
        });
      } else {
        return question;
      }
    });
    const currentAnswerIndex = this.getCurrentAnswerIndex(answerId);
    let serviceNavigationBar = this.getUpdatedServiceNavigationBar(selectedAnswers);
    this.setState({
      [currentSurveyName]: currentSurveyState,
      currentAnswer: currentAnswerIndex,
      serviceNavigationBar: serviceNavigationBar,
      currentList: this.SERVICE_LIST
    });
    console.log(currentAnswerIndex);
    if (currentType === "rating-selection") {
      this.updateRatingHighlight(currentAnswerIndex);
    };
  };

  /******************
   * Public methods *
   ******************/

  /*******************
   * Lifecycle hooks *
   *******************/

  componentWillReceiveProps(nextProps) {
    const headerImage =
      this.props.match.params.question !== nextProps.match.params.question && nextProps.match.params.question > 0
        ? require(`./images/Question${nextProps.match.params.question}.png`)
        : this.state.headerImage;
    const survey = this.getSurvey(nextProps);
    const nextQuestion = this.getQuestionIndex(nextProps);
    const serviceNavigationBar = this.getUpdatedServiceNavigationBar(
      survey.questions[nextQuestion].selectedAnswers,
      nextProps
    );
    this.setState({
      headerImage: headerImage,
      serviceNavigationBar: serviceNavigationBar
    });
  }

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    const questionsDisable = this.state.currentList !== this.QUESTION_LIST;
    const questionsUnfocused = questionsDisable || !!this.props.match.params.popup;
    const serviceDisable = this.state.currentList !== this.SERVICE_LIST;
    const serviceUnfocused = serviceDisable || !!this.props.match.params.popup;
    const currentSurvey = this.getSurvey();
    const questionIndex = this.getQuestionIndex();
    return (
      <div className="feedback-question">
        <ImageHeader id="header" src={this.state.headerImage} {...this.state.headerImageStyles} />
        <ImageText id="text" src={this.state.textImage} />
        <img className="question" src={currentSurvey.questions[questionIndex].question} alt="" />
        <ImageButtonList
          id="QuestionList"
          imageButtons={currentSurvey.questions[questionIndex].answers}
          customImage={currentSurvey.questions[questionIndex].custom_image}
          flexClass={currentSurvey.questions[questionIndex].flex}
          unfocused={questionsUnfocused}
          disabled={questionsDisable}
          currentButton={this.state.currentAnswer}
          handleKeyUp={this.handleKeyUp}
        />
        <ServiceNavigationBar
          id="ServiceNavigationBar"
          unfocused={serviceUnfocused}
          disabled={serviceDisable}
          buttons={Array.from(this.state.serviceNavigationBar.buttons)}
          currentButton={this.state.serviceNavigationBar.default}
          handleKeyUp={this.handleKeyUp}
        />
        <NavigationBar {...this.state.navigationBar} />
        {this.props.match.params.popup && <Popup popup={this.props.match.params.popup} />}
      </div>
    );
  }
}

const ConnectedFeedbackQuestion = connect(
  state => ({
    context: state.application.currentContext,
    currentPatient: state.application.currentPatient,
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        ...applicationActions
      },
      dispatch
    )
  })
)(FeedbackQuestion);

export default withRouter(ConnectedFeedbackQuestion);
